export default __webpack_public_path__ + "static/media/Captcha.e0675e98.png";